import React, { memo } from 'react'
import InfoIcon from 'transfix-icons/build/InfoIcon'
import Typography from 'transfix-ui/core/Typography'
import { makeStyles } from 'transfix-ui/core/styles'
import { brandColors } from 'transfix-ui/theme/colors'
import { IShipmentMissingInfo, Maybe } from 'types/FMSGraphqlTypes'
import { getMissingInformationLabel } from './utils'

const useMissingInformationStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  icon: {
    order: 1,

    [theme.breakpoints.up('lg')]: {
      order: 2,
    },
  },
  labels: {
    order: 2,
    textAlign: 'left',

    [theme.breakpoints.up('lg')]: {
      order: 1,
      textAlign: 'right',
    },
  },
  message: {
    color: brandColors.warning1,
  },
}))

export interface IMissingInformationProps {
  missingInformation: IShipmentMissingInfo[]
  /**
   * @default null
   */
  message?: Maybe<string>
}

const MissingInformation = memo<IMissingInformationProps>(
  ({ message = null, missingInformation }) => {
    const classes = useMissingInformationStyles()

    const missingInformationLabel = getMissingInformationLabel({ missingInformation })

    return (
      <div className={classes.root}>
        <InfoIcon size='large' color='warning1' className={classes.icon} />
        <div className={classes.labels}>
          {message && (
            <Typography variant='body2' component='div' className={classes.message}>
              {message}
            </Typography>
          )}
          <Typography variant='subtitle2' component='div' color='textPrimary'>
            {missingInformationLabel}
          </Typography>
        </div>
      </div>
    )
  }
)

export default MissingInformation
